import React, { useState, useEffect } from "react";
import dashboardIcon2 from "../../BuisnessDashboard/Images/dashboardIcon2.svg";
import dashboardIcon2Selected from "../../BuisnessDashboard/Images/dashboardIcon2Selected.svg";
import users2 from "../../BuisnessDashboard/Images/2users.svg";
import users2Selected from "../../BuisnessDashboard/Images/users2Selected.svg";
import analyticsIcon from "../../BuisnessDashboard/Images/analyticsIcon.svg";
import analyticsIconselected from "../../BuisnessDashboard/Images/analyticsIconselected.svg";
import rejectionIcon from "../../BuisnessDashboard/Images/rejectionIcon.svg";
import rejectionIconSelectee from "../../BuisnessDashboard/Images/rejectionIconSelectee.svg";
import sidbaricon1010 from "../../BuisnessDashboard/Images/sidbaricon1010.svg";
import sidbaricon1010Selected from "../../BuisnessDashboard/Images/sidbaricon1010Selected.svg";
import conversionIcon from "../../BuisnessDashboard/Images/conversionIcon.svg";
import conversionIconSelected from "../../BuisnessDashboard/Images/conversionIconSelected.svg";
import buisnessTravelBag from "../../BuisnessDashboard/Images/buisnessTravelBag.svg";
import buisnessTravelBagSelected from "../../BuisnessDashboard/Images/buisnessTravelBagSelected.svg";
import riskIcon from "../../BuisnessDashboard/Images/riskIcon.svg";
import riskIconSelected from "../../BuisnessDashboard/Images/riskIconSelected.svg";

import Overview from "./Overview";
import LeadFunnelJourney from "./LeadFunnelJourney/LeadFunnelJourney";
import LeadDemographicProfile from "./LeadDemographicProfile/LeadDemographicProfile";
import RejectionIntelligence from "./RejectionIntelligence/RejectionIntelligence";
import AggregatorPerformance from "./AggregatorPerformance/AggregatorPerformance";
import Conversion from "./Conversion/Conversion";
import Business from "./Business/Business";
import RiskQuality from "./RiskQuality/RiskQuality";
import moment from "moment";
import DateFilterSelect from "../../../../CustomDatePicker/DateFilterSelectold";

const tabsData = [
  {
    name: "Overview",
    icon: dashboardIcon2,
    value: "overview",
    selectedIcon: dashboardIcon2Selected,
  },
  // {
  //   name: "Lead Funnel and Journey",
  //   icon: users2,
  //   value: "leadFunnelJourney",
  //   selectedIcon: users2Selected,
  // },
  {
    name: "Lead Demographics and Profile",
    icon: analyticsIcon,
    value: "leadDemographicProfile",
    selectedIcon: analyticsIconselected,
  },
  {
    name: "Rejection Intelligence",
    icon: rejectionIcon,
    value: "rejectionIntelligence",
    selectedIcon: rejectionIconSelectee,
  },
  {
    name: "Aggregator Performance",
    icon: sidbaricon1010,
    value: "aggregatorPerformance",
    selectedIcon: sidbaricon1010Selected,
  },
  {
    name: "Conversion and Deviation",
    icon: conversionIcon,
    value: "conversionDeviation",
    selectedIcon: conversionIconSelected,
  },
  {
    name: "Business and Revenue",
    icon: buisnessTravelBag,
    value: "businessRevenue",
    selectedIcon: buisnessTravelBagSelected,
  },
  // {
  //   name: "Risk and Quality",
  //   icon: riskIcon,
  //   value: "riskQuality",
  //   selectedIcon: riskIconSelected,
  // },
];

export default function Main({ handleFilter, commonFilter }) {
  const [currentTab, setCurrentTab] = useState(tabsData?.[0]?.value);
    const [view, setView] = useState("chart");
  const handleTabs = (type) => {
    setCurrentTab(type);
  };
  // const [dateFilterPopup, setDateFilterPopup] = useState({ show: false, from: moment().subtract(6, 'days').format("YYYY-MM-DD"), to: moment(new Date).format("YYYY-MM-DD") })
  const [dateFilterPopup, setDateFilterPopup] = useState({ show: false, from: commonFilter?.fromDate, to: commonFilter?.toDate  })


  const [appliedDate, setAppliedDate] = useState({
    from: moment(new Date()).format("YYYY-MM-DD"),
    to: moment(new Date()).format("YYYY-MM-DD"),
  });

  const [isFilterCleared, setIsFilterCleared] = useState(false);


  useEffect(() => {
    if (
      commonFilter?.fromDate !== dateFilterPopup.from ||
      commonFilter?.toDate !== dateFilterPopup.to
    ) {
      setAppliedDate((prev) => ({
        ...prev,
        from: commonFilter.fromDate,
        to: commonFilter.toDate
      }));
    }
    // const obj = { from: commonFilter.fromDate, to: commonFilter.toDate }

  }, [commonFilter]);

  const handleDateFilterPopup = (type, val) => {
    setDateFilterPopup((prev) => ({ ...prev, [type]: val }));
  };

  const handleApplyDateFilter = () => {
    handleDateFilterPopup("show", false);
    handleDateApply()
  };

  const handleDateApply = () => {
    setAppliedDate({
      from: dateFilterPopup.from,
      to: dateFilterPopup.to,
    });

    if (type === "from") {
      if (commonFilter.fromDate !== formatted) {
        handleFilter("fromDate", formatted);
      }
    } else {
      if (commonFilter.toDate !== formatted) {
        handleFilter("toDate", formatted);
      }
    }
  };
  const handleReset = () => {
    const today = moment().format("YYYY-MM-DD");
    setIsFilterCleared(true)

    setAppliedDate({
      from: today,
      to: today,
    });

    setDateFilterPopup({
      show: false,
      from: today,
      to: today,
    });
    setTimeout(() => setIsFilterCleared(false), 0);

  };
  return (
    <>
      <div className="OverView-Main-Section">
        <div className="customTabsHeaders" style={{ marginTop: "20px" }}>
          {tabsData?.map((val, id) => {
            return (
              <div
                className={`currentTsba ${currentTab == val?.value ? "active" : ""}`}
                onClick={() => handleTabs(val?.value)}
              >
                <img
                  src={currentTab == val?.value ? val?.selectedIcon : val?.icon}
                />
                <h5 style={{ fontSize: window.innerWidth > 1800 ? "15px" : "13px" }}>{val?.name}</h5>
              </div>
            );
          })}
        </div>
      </div>

      <div className="liveReports-section">
        <div className="HeadingFilter-main-filters" style={{ marginBottom: '40px' }}>
          <div className="" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h2 className="headings">
              {currentTab == "overview"
                ? "Executive Summary"
                // : 
                // currentTab == "leadFunnelJourney"
                //   ? "Lead Funnel and Journey"
                : currentTab == "leadDemographicProfile"
                  ? "Lead Demographics and Profile"
                  : currentTab == "rejectionIntelligence"
                    ? "Rejection Intelligence"
                    : currentTab == "aggregatorPerformance"
                      ? "Aggregator Performance"
                      : currentTab == "conversionDeviation"
                        ? "Conversion and Deviation"
                        : currentTab == "businessRevenue"
                          ? "Business & Revenue"
                          : currentTab == "riskQuality"
                            ? "Risk & Quality"
                            : ""}
            </h2>
            <div className="" style={{ display: 'flex', gap: '15px' }}>
              {/* <div className="custom-popup" style={{ width: "100%" }}>
                <div
                  className="customSelectBox "
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleDateFilterPopup("show", !dateFilterPopup?.show)
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "7px",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 9 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 0.75V2.25M3 0.75V2.25"
                        stroke="#0C0B10"
                        stroke-width="0.5625"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.875 1.5H4.125C2.71079 1.5 2.00368 1.5 1.56434 1.93934C1.125 2.37868 1.125 3.08579 1.125 4.5V5.25C1.125 6.6642 1.125 7.37134 1.56434 7.81065C2.00368 8.25 2.71079 8.25 4.125 8.25H4.875C6.2892 8.25 6.99634 8.25 7.43565 7.81065C7.875 7.37134 7.875 6.6642 7.875 5.25V4.5C7.875 3.08579 7.875 2.37868 7.43565 1.93934C6.99634 1.5 6.2892 1.5 4.875 1.5Z"
                        stroke="#0C0B10"
                        stroke-width="0.5625"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M1.125 3.75H7.875"
                        stroke="#0C0B10"
                        stroke-width="0.5625"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    {dateFilterPopup?.from && dateFilterPopup?.to
                      ? `${moment(dateFilterPopup?.from).format("DD MMM YYYY")} - ${moment(dateFilterPopup?.to).format("DD MMM YYYY")}`
                      : "Select Date Range"}
                  </div>
                  <div style={{ marginTop: "-5px" }}>
                    <svg
                      width="8"
                      height="4"
                      viewBox="0 0 8 4"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.375 0.375025C7.375 0.375025 4.79731 3.375 3.875 3.375C2.95263 3.375 0.375 0.375 0.375 0.375"
                        stroke="#686C70"
                        stroke-width="0.75"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                {dateFilterPopup?.show ? (
                  <CustomDateFilter
                    payload={dateFilterPopup}
                    handlechange={handleDateFilterPopup}
                    handleApply={handleApplyDateFilter}
                  />
                ) : (
                  ""
                )}
              </div> */}
              <DateFilterSelect
                value={[new Date(commonFilter.fromDate), new Date(commonFilter.toDate)]}
                onChange={(range) => {
                  handleDateFilterPopup("from", range[0]);
                  handleDateFilterPopup("to", range[1]);

                  handleFilter("fromDate",  moment(range[0]).format("YYYY-MM-DD"));
                  handleFilter("toDate", moment(range[1]).format("YYYY-MM-DD"));
                }}
                isFilterCleared={isFilterCleared}
                 customStyle={{ height: "100%", fontSize: '14px', alignItems: 'center' }}
              />

              {(currentTab === "leadDemographicProfile" ||
                  currentTab === "rejectionIntelligence") && (
                    <div style={{ display: "flex", alignItems: "center", gap: "4px", background: "#f3f4f6", borderRadius: "8px", padding: "4px" }}>
                      <button
                        onClick={() => setView("table")}
                        style={{
                          display: "flex", alignItems: "center", justifyContent: "center",
                          width: "32px", height: "32px", borderRadius: "6px", border: "none",
                          cursor: "pointer",
                          background: view === "table" ? "#fff" : "transparent",
                          color: view === "table" ? "#249578" : "#9ca3af",
                          boxShadow: view === "table" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                          transition: "all 0.2s",
                        }}
                        title="Table view"
                      >
                        <i className="fa fa-table" style={{ fontSize: "12px" }} />
                      </button>
  
                      <button
                        onClick={() => setView("chart")}
                        style={{
                          display: "flex", alignItems: "center", justifyContent: "center",
                          width: "32px", height: "32px", borderRadius: "6px", border: "none",
                          cursor: "pointer",
                          background: view === "chart" ? "#fff" : "transparent",
                          color: view === "chart" ? "#249578" : "#9ca3af",
                          boxShadow: view === "chart" ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                          transition: "all 0.2s",
                        }}
                        title="Chart view"
                      >
                        <i className="fa fa-bar-chart" style={{ fontSize: "12px" }} />
                      </button>
                    </div>
                  )}
              {/* <div
                className="custom-btn"
                role="button"
                onClick={handleDateApply}
              >
                <i
                  class="fa fa-filter"
                  style={{
                    fontSize: window.innerWidth >= 1800 ? "20px" : "",
                  }}
                  aria-hidden="true"
                ></i>
              </div> */}
              <div className="custom-btn" role="button" onClick={handleReset}>
                <i
                  class="fa fa-times"
                  style={{
                    fontSize: window.innerWidth >= 1800 ? "20px" : "",
                  }}
                  aria-hidden="true"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ margin: window.innerWidth > 1800 ? "0 70px" : '0' }}>
        {currentTab == "overview" ? <Overview appliedDate={dateFilterPopup} /> : ""}
        {/* {currentTab == "leadFunnelJourney" ? <LeadFunnelJourney /> : ""} */}
        {currentTab === "leadDemographicProfile" ? (
          <LeadDemographicProfile
            appliedDate={dateFilterPopup}
            view={view}
          />
        ) : (
          ""
        )}

        {currentTab === "rejectionIntelligence" ? <RejectionIntelligence appliedDate={dateFilterPopup} view={view}/> : ""}

        {currentTab === "aggregatorPerformance" ? <AggregatorPerformance appliedDate={dateFilterPopup} /> : ""}

        {currentTab === "conversionDeviation" ? <Conversion appliedDate={dateFilterPopup} /> : ""}

        {currentTab === "businessRevenue" ? <Business appliedDate={dateFilterPopup} /> : ""}

        {currentTab === "riskQuality" ? <RiskQuality /> : ""}
      </div>
    </>
  );
}
